/**
 * Plantilla por defecto para el quiz del escenario 5 (criterios GLOSEN 2023 a los 3 meses).
 * options: id, text (a), b), c), d)), correct, explanation (HTML del contenido del criterio).
 */
export const DEFAULT_SCENARIO5_OPTIONS = [
	{
		id: 1,
		text: "a)",
		correct: false,
		explanation: `<div><strong>Función renal (eGFR):</strong> normal o ≤40 % inferior al valor prebrote.</div>
<div><strong>Proteinuria (g/24 h, g/g):</strong> Reducción &gt;20 %.</div>
<div><strong>Sedimento urinario:</strong> &lt;15 hematíes/campo.</div>
<div><strong>Actividad inmunológica (anti-dsDNA, C3/C4) :</strong> descenso progresivo.</div>`,
		confirmExplanation: "",
	},
	{
		id: 2,
		text: "b)",
		correct: false,
		explanation: `<div><strong>Función renal (eGFR):</strong> normal o ≤20 % inferior.</div>
<div><strong>Proteinuria (g/24 h, g/g):</strong> respuesta parcial o completa.</div>
<div><strong>Sedimento urinario:</strong> &lt;15 hematíes/campo o inactivo.</div>
<div><strong>Actividad inmunológica (anti-dsDNA, C3/C4):</strong> descenso progresivo.</div>`,
		confirmExplanation: "",
	},
	{
		id: 3,
		text: "c)",
		correct: false,
		explanation: `<div><strong>Función renal (eGFR):</strong> normal o ≤40 % inferior al valor prebrote.</div>
<div><strong>Proteinuria (g/24 h, g/g):</strong> Reducción &gt;25 %.</div>
<div><strong>Sedimento urinario:</strong> &lt;15 hematíes/campo.</div>
<div><strong>Actividad inmunológica (anti-dsDNA, C3/C4):</strong> actividad baja o ausente.</div>`,
		confirmExplanation: "",
	},
	{
		id: 4,
		text: "d)",
		correct: true,
		explanation: `<div><strong>Función renal (eGFR):</strong> normal o ≤50 % inferior al valor prebrote.</div>
<div><strong>Proteinuria (g/24 h, g/g):</strong> Reducción &gt;25 %.</div>
<div><strong>Sedimento urinario:</strong> &lt;15 hematíes/campo.</div>
<div><strong>Actividad inmunológica (anti-dsDNA, C3/C4):</strong> descenso progresivo de la actividad inmunológica.</div>`,
		confirmExplanation: "",
	},
];
